/* eslint no-use-before-define: 0 */
import * as $ from "jquery";

(function main($) {
    $(document).ready(() => {
        //if there are more buttons then one
        if ($('.login-info-area').children().length > 1) { 
            $('.login-area').css("flex-direction", "column");
            $('.login-info-area').css("margin-top", "0px");
        }

        var mobileSearch = $("#mobile-input-container");
        var mobileLanguage = $("#mobile-header-language-menu");

        $(".mobile-search-toggler").on("click", () => {
            mobileSearch.toggleClass("show-visibility");

            if (!mobileLanguage.hasClass("show-visibility")) {
                mobileLanguage.toggleClass("show-visibility");
            }
            if ($("nav.site-main-navigation > ul").css('display') == 'block') {
                $("nav.site-main-navigation > ul").toggle();
            }
        });
        $(".mobile-language-toggler").on("click", () => {
            mobileLanguage.toggleClass("show-visibility");

            if (!mobileSearch.hasClass("show-visibility")) {
                mobileSearch.toggleClass("show-visibility");
            }
            if ($("nav.site-main-navigation > ul").css('display') == 'block') {
                $("nav.site-main-navigation > ul").toggle();
            }
        });

        var mobileHeader = $("#mobile-header-container");
        if (mobileHeader == null || mobileHeader.length == 0)
        {
            var mobileMenu = $(".mobile-menu");
            mobileMenu.toggleClass("show-visibility");
        }

        var desktopSearch = $("#input-container");
        $(".search-toggler").on("click", () => {
            desktopSearch.toggleClass("show-visibility");
            $(".search-toggler").toggleClass("show-visibility");
            $(".header-search").trigger("focus");
        });

        $('.search-toggler').on('keypress', function (e) {
            if (e.which === 13) {
                $(this).trigger('click');
            }
        });
    });
}($));